/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Grid",
  size: 20
}

const SvgGrid = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path d="M2 2h3v3H2zM8 2h3v3H8zM14 2h3v3h-3zM2 8h3v3H2zM8 8h3v3H8zM14 8h3v3h-3zM2 14h3v3H2zM8 14h3v3H8zM14 14h3v3h-3z" />
  </Svg>
)

SvgGrid.defaultProps = defaultProps
export default SvgGrid
